import { useEffect } from 'react';
import resolveSocketService from '../resolveSocketService';
import { ListenEvents } from '../socketEventNames';

export default function useSocketEvent<T>(
  eventType: ListenEvents | undefined,
  callback: (eventData: T) => void,
) {
  useEffect(() => {
    if (!eventType) return;

    resolveSocketService.addListener(eventType, callback);

    return () => {
      resolveSocketService.removeListener(eventType, callback);
    };
  }, [eventType, callback]);
}
